<script setup lang="ts">
/** Badge de niveau d'urgence — le label texte porte l'info (conforme MASTER §1). */
import { computed } from 'vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import type { AccompUrgency } from '@/v2/accompagnement/api/accompagnementTypes'
import { ACCOMP_URGENCY_META } from '@/v2/accompagnement/constants/accompagnementConstants'

const props = defineProps<{ urgency: AccompUrgency }>()

const meta = computed(() => ACCOMP_URGENCY_META[props.urgency])
</script>

<template>
  <span class="badge badge-sm gap-1 whitespace-nowrap" :class="meta.badgeClass">
    <ExclamationTriangleIcon
      v-if="urgency === 'PRIORITAIRE'"
      class="h-3.5 w-3.5"
      aria-hidden="true"
    />
    {{ meta.label }}
  </span>
</template>
